<template>
	<PlanVersionHeaderDisplay
		:key="`${index}cardHeader`"
		v-if="cloudSyncEnabled"
		v-model:selectedPlan="selectedPlan"
		:plan="plan"
		:index="index"
		:autoloadLatestPlan="autoloadLatestPlan"
		:selectedPriceBook="selectedPriceBook"
		:appointmentId="appointmentId"
		@planSelected="(args) => emit('selectedPlanChange', args)"
		@createNewPlan="(args) => emit('createNewPlan', args)"
	>
	</PlanVersionHeaderDisplay>
	<div
		class="grid-auto-rows-[72px] grid w-full grid-cols-12 flex-row gap-x-8 gap-y-5 px-4 pb-4"
	>
		<FormKit
			outer-class="col-span-4 max-w-full"
			type="text"
			name="firstName"
			:label="t('person.firstName')"
			validation="required"
			ref="firstNameRef"
			data-test-id="first-name"
		/>

		<FormKit
			outer-class="col-span-4 max-w-full"
			type="text"
			name="middleName"
			:label="t('person.middleName')"
		/>

		<FormKit
			outer-class="col-span-4 max-w-full"
			type="text"
			name="lastName"
			:label="t('person.lastName')"
		/>

		<FormKit
			outer-class="col-span-3 max-w-full"
			type="text"
			name="address"
			:label="t('person.address')"
		/>

		<FormKit
			outer-class="col-span-3 max-w-full"
			type="text"
			name="city"
			:label="t('person.city')"
		/>
		<FormKit
			outer-class="col-span-3 max-w-full"
			type="dropdown"
			name="state"
			:label="t('person.state')"
			:placeholder="
				t('plan.placeholders.select', {
					placeholderLabel: t('person.state'),
				})
			"
			:options="stateOptions"
		/>

		<FormKit
			outer-class="col-span-3 max-w-full"
			type="text"
			name="zip"
			:label="t('person.zip')"
			validation="matches: /^\d{5}(-\d{4})?$/"
			validation-visibility="live"
		/>

		<FormKit
			outer-class="col-span-6 max-w-full"
			type="tel"
			name="phone"
			:label="t('person.phone')"
			placeholder="xxx-xxx-xxxx"
			:validation="[['matches', /^\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/]]"
			:validation-messages="{
				matches: `${t('plan.validationMessages.phone')}`,
			}"
			validation-visibility="live"
		/>
		<FormKit
			outer-class="col-span-6 max-w-full"
			type="email"
			name="email"
			:label="t('person.email')"
			validation="email"
			validation-visibility="dirty"
			:placeholder="t('plan.placeholders.email')"
		/>
	</div>
</template>

<script setup lang="ts">
import type { PriceBook } from '@/classes/PriceBook'
import { stateOptions } from '@/data/stateOptions'
import type { PlanData } from '@/types'
import PlanVersionHeaderDisplay from '@/views/NewSession/PlanVersions/PlanVersionHeaderDisplay.vue'
import type { PropType } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const selectedPlan = defineModel('selectedPlan', {
	type: [String, null],
	required: false,
})

const emit = defineEmits(['createNewPlan', 'selectedPlanChange'])

defineProps({
	appointmentId: [String, null],
	autoloadLatestPlan: { type: Boolean, required: true },
	cloudSyncEnabled: Boolean,
	index: { type: Number, required: true },
	plan: Object as PropType<Partial<PlanData>>,
	selectedPriceBook: Object as PropType<PriceBook | undefined>,
})
</script>
